<template>
<div id="q-app">

           <q-layout view="lHh Lpr lFf">
                <q-layout-header :reveal='$q.screen.lt.md'>
                  <q-toolbar
                    color="primary"
                    size="35px"
                    class=""
                  >
                    <q-btn
                      flat
                      @click="leftDrawerOpen = !leftDrawerOpen"
                      aria-label="Menu"
                      v-if="loggedIn"
                      icon = 'menu'
                    >
                    </q-btn>

                    <q-toolbar-title  class='gt-xs'>{{companyName}}<div slot="subtitle">{{ allowTo }}</div></q-toolbar-title>

                    <avatar v-if="loggedIn"
                        :fullname=getLoginUser() 
                        :size="50"
                        color='green'
                    />

                    <q-toolbar-title  shrink v-if="loggedIn" >
                         {{getLoginUser()}}                         
                      <!-- <div slot="subtitle">директор</div> -->
                    </q-toolbar-title>
                    
                    <q-btn v-if="loggedIn && $q.fullscreen.isCapable" flat @click="toFullScreen" icon='fullscreen'/> 


                    <q-btn v-if="loggedIn" flat icon="exit_to_app" @click="$router.push('logout')"/>

                  </q-toolbar>

                </q-layout-header>

                <q-layout-drawer
                  v-model="leftDrawerOpen"
                  v-if="loggedIn"
                  behavior="default"
                  :width=300
                  content-class="['bg-grey-3', 'q-pa-sm']">

                  <q-list
                    no-border
                    link
                    inset-delimiter>
                    
                    <q-list-header>

                        <img src="./../static/logo.jpg" style="width: 305px; margin: -20px; margin-top: -30px; margin-bottom: 5px;">

                    </q-list-header>

                    <q-item @click.native = "$router.push('orders')" v-if='$store.getters.isAllowPermission("manager-terminal")'>
                      <q-item-side icon="fas fa-cogs" />
                      <q-item-main label="Терминал менеджера" sublabel="управление заказами" />
                    </q-item>

                    <q-item @click.native = "$router.push('printTerminal')" v-if='$store.getters.isAllowPermission("print-terminal")'>
                      <q-item-side icon="fas fa-palette" />
                      <q-item-main label="Терминал печатника"  sublabel="заказы в печати"/>
                    </q-item>                    
                    
                    <q-item @click.native = "$router.push('reports')" v-if='$store.getters.isAllowPermission("manager-terminal")'>
                      <q-item-side icon="fas fa-chart-line" />
                      <q-item-main label="Отчеты"  sublabel="отчеты и аналитика"/>
                    </q-item>                    



                    <q-item @click.native = "$router.push('prices')" v-if='$store.getters.isAllowPermission("price-terminal")'>
                      <q-item-side icon="fas fa-hand-holding-usd" />
                      <q-item-main label="Прайсы" sublabel="редактирование прайс-листов" />
                    </q-item>



                    <q-item @click.native = "$router.push('materials')" v-if='$store.getters.isAllowPermission("material-terminal")'>
                      <q-item-side icon="fas fa-cart-plus" />
                      <q-item-main label="Материалы" sublabel="добаление  материалов" />
                    </q-item>


                    <q-item @click.native = "$router.push('contragents')" v-if='$store.getters.isAllowPermission("contragent-terminal")'>
                      <q-item-side icon="far fa-address-book" />
                      <q-item-main label="Контрагенты" sublabel="Редактирование контрагентов" />
                    </q-item>

                    <q-item @click.native = "$router.push('executers')" v-if='$store.getters.isAllowPermission("*")'>
                      <q-item-side icon="fas fa-people-carry"/>
                      <q-item-main label="Исполнители" sublabel="Редактирование списка исполнителей" />
                    </q-item>

                    <q-item @click.native = "$router.push('charges')" v-if='$store.getters.isAllowPermission("add-beznal")'>
                      <q-item-side icon="fas fa-piggy-bank" />
                      <q-item-main label="Банковские приходы" sublabel="безналичные платежи" />
                    </q-item>

                    <!-- <q-item @click.native = "$router.push('users')" v-if='$store.getters.isAllowPermission("*")'>
                      <q-item-side icon="fas fa-users-cog" />
                      <q-item-main label="Пользователи системы" sublabel="редактор пользователей" />
                    </q-item> -->

                    <q-item @click.native = "$router.push('tuning')" v-if='$store.getters.isAllowPermission("*")'>
                      <q-item-side icon="fab fa-whmcs" />
                      <q-item-main label="Параметры системы" sublabel="общие параметры системы" />
                    </q-item>



                  </q-list>
                </q-layout-drawer>

                <q-page-container @click.native="hideMainMenu">
                  <router-view />
                </q-page-container>

              </q-layout>
                <div class='z-top fixed-bottom-right'>
                    <div v-for='(item, index) in uploadList' :key='index'>
                        <div class='bg-grey-1 q-ma-xs q-mr-lg shadow-1 q-pa-xs' style='width:150px; height:40px; border-radius:3px; border:1px;' v-bind:class="{'bg-green':(item.percent==100)}">
                            <q-progress
                                :percentage=item.percent
                                :buffer="100"
                                style="height: 10px"
                            />
                            <div class='text-grey-5 q-caption q-ma-xs ellipsis'>
                                {{item.name}}
                            </div>
                        </div>

                    </div>

                </div>  

                <!-- добавляем окна стандартных диалогов -->
                <addContragentDialog/>            

                
  </div>
</template>

<script>
/* eslint-disable */
import { openURL } from 'quasar'
import Avatar from 'vue-avatar-component'
import addContragentDialog from './components/contragents/contragentEditDialog';
import axios from 'axios';


export default {
  name: 'LayoutDefault',
  components: {
      Avatar,
      addContragentDialog,
  },
  data () {
    return {
        leftDrawerOpen: false,
    }
  },

  created() {
        var self = this; 
        axios.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                if (401 === error.response.status) { // если не авторизован - то разлогиниваемся
                    console.log('upss..')
                    self.$router.push('/logout')
                } else {
                    return Promise.reject(error); // если другая ошибка - передаем ее дальше
                }
            }
        );
      
      this.$store.getters.ds.login({
        username: 'admClient', password: 'a4re2ta'
      }, (logged, data) => {
        console.log('Соединение установлено');
      });
      
      //=============== получаем разрешения, если их вдруг нету почему - то
      if (this.$store.getters.getPermissions.length==0) {
          this.$store.dispatch('getPermissions');
      }



  },




  methods: {
    openURL,

    toFullScreen() {
        console.log('to full')
        this.$q.fullscreen.toggle()
    },

    getLoginUser() {
        let result = '';
        const u = this.$store.getters.getLoginUser;
        if (u != undefined) {
             result = u;
        }
        return result;
    },

    hideMainMenu() {

      this.leftDrawerOpen = false;

    }



  },
  computed : {
        allowTo() {
            let q = this.$store.getters.getMyCompany;
            return q != null ? q.active_to ? 'Доступно до ' + q.active_to.split('-').reverse().join('-') : 'power by Advimatic' : 'power by Advimatic';
        },
        companyName() {
            let q = this.$store.getters.getMyCompany;
            return q != null?q.name:'';
        },

        loggedIn() {
            return this.$store.getters.loggedIn
        },
        
        uploadList() { //список загружаемых в облако файлов
            return this.$store.getters.getUploadingFiles;
        }

  }

}
</script>

<style lang="scss" scoped>
    nav {
        display: flex;
        list-style: none;
        padding: 15px 0;
        margin: 0;
        justify-content: flex-end;
        background: #F5F8FA;
        border-bottom: 1px solid lightgrey;
        margin-bottom: 24px;

        .this-logo-image {
            width: 305px;
            margin: -20px;
            margin-top: -25px;
            margin-bottom: 25px;
        }

    }
    .nav a {
        color: #636b6f;
        padding: 0 25px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: .1rem;
        text-decoration: none;
        text-transform: uppercase;
    }
</style>
